/**
 * This is simple JWT API for testing purposes.
 * https://github.com/pinia-studio/jwt-api-node
**/

export const JWT_HOST_API = "https://jwt-api-node.vercel.app";

export const KEYCLOAK_CONFIG = {
    url: import.meta.env.VITE_KEYCLOAK_URL || "https://auth.dev.henddu.com",
    realm: import.meta.env.VITE_KEYCLOAK_REALM || "henddu-system",
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "henddu-monitoring-web"
  };